module.exports = __webpack_public_path__ + "img/germany-lung-cancer-male.38a382b0.png";